const LEGACY_PROTOCOL_MAJOR = 1
const LEGACY_PROTOCOL_MINOR = 0
const CAPABILITY_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/

function readMarkerVersion (markerText) {
  if (typeof markerText !== 'string') return null
  const version = markerText.split(':')[0].trim()
  return version || null
}

function readResponseVersion (reply) {
  if (!reply || typeof reply.extensionVersion !== 'string') return null
  const version = reply.extensionVersion.trim()
  return version || null
}

function isProtocolVersion (value) {
  return value &&
    Number.isInteger(value.major) && value.major > 0 &&
    Number.isInteger(value.minor) && value.minor >= 0
}

function isCapabilityList (value) {
  return Array.isArray(value) && value.every(capability => (
    typeof capability === 'string' && CAPABILITY_PATTERN.test(capability)
  ))
}

function createLegacyRuntimeInfo (installed, extensionVersion) {
  return {
    installed,
    extensionVersion,
    protocolMajor: LEGACY_PROTOCOL_MAJOR,
    protocolMinor: LEGACY_PROTOCOL_MINOR,
    capabilities: [],
    mode: 'legacy-v1',
  }
}

/**
 * 把旧版和增强版 CHECKINSTALL 响应归一为可序列化状态。
 * 扩展版本只作诊断；只有合法协议版本与 capability 列表同时存在时才启用能力感知。
 */
export function normalizeInstallResponse (reply, markerText = '') {
  const extensionVersion = readResponseVersion(reply) || readMarkerVersion(markerText)
  const installed = !!(reply && reply.installStatus)
  const legacyInfo = createLegacyRuntimeInfo(installed, extensionVersion)

  if (!installed || !isProtocolVersion(reply.protocolVersion) || !isCapabilityList(reply.capabilities)) {
    return legacyInfo
  }

  return {
    installed: true,
    extensionVersion,
    protocolMajor: reply.protocolVersion.major,
    protocolMinor: reply.protocolVersion.minor,
    capabilities: [...reply.capabilities],
    mode: 'capability-aware',
  }
}

/** 未来新行为只能按明确 capability 开启，不能按扩展或协议版本猜测。 */
export function supportsCapability (runtimeInfo, capability) {
  return !!runtimeInfo &&
    runtimeInfo.installed === true &&
    runtimeInfo.mode === 'capability-aware' &&
    Array.isArray(runtimeInfo.capabilities) &&
    runtimeInfo.capabilities.includes(capability)
}
